<template>
	<div class="tab-box">
		<div class="tab flex">
			<div v-for="(item, i) in tab" :key="i" class="item flex-grow flex-center" :class="{'z-crt': currentIndex == i}" @click="clickHandle(i)">{{item.name}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			tab: Array,
			value: [String, Number]
		},
		
		data() {
			return {
				currentIndex: ''
			}
		},
		
		watch: {
			value(val) {
				if (this._stop) {
					delete this._stop;
					return;
				}
				this.clickHandle(val);
			}
		},
		
		mounted() {
			this.clickHandle(this.value || 0);
		},
		
		methods: {
			clickHandle(i) {
				if (this.currentIndex === i) return;
				this.currentIndex = i;
				this._stop = true;
				this.$emit('input', i);
				this.$emit('change', this.tab[i], i);
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.tab {
		z-index: 100;
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		background: #fff;
		
		&-box {
			height: .88rem;
			
			elder({
				height: 1rem
			})
		}
		
		.item {
			position: relative;
			line-height: .88rem;
			font-size: .32rem;
			font-weight: bold;
			color: #363A44;
			
			elder({
				line-height: 1rem,
				font-size: .4rem
			})
			
			&.z-crt {
				color: #0366F1;
				
				&:after {
					content: '';
					position: absolute;
					left: 50%;
					bottom: 0;
					width: .8rem;
					height: .04rem;
					margin-left: -.4rem;
					background: #0366F1;
					
					elder({
						height: .06rem
					})
				}
			}
		}
	}
</style>